// @file Store for current user
import { getVuexStore } from '@@/bits/pinia'
import { defineStore } from 'pinia'
import type { UserWithHashId } from 'types'
import { computed } from 'vue'
import type { RootState } from 'vuexstore/surface/types'

export const useSurfaceCurrentUserStore = defineStore('surfaceCurrentUser', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  // Getters
  const currentUser = computed<UserWithHashId | undefined>(() => surfaceVuexStore?.getters.user)

  return {
    // Getters
    currentUser,
  }
})
